<script setup lang="ts">
import { LoanType } from '@/helpers/const';
import { useDischargeRequestProcess } from '@/helpers/useDischargeRequestProcess';
import router from '@/router';
import { DischargeRequestProcessSteps, type DischargeRequestProcessStepEnum } from '@/types';
import { onBeforeMount } from 'vue';
import type { RouteParamsRaw } from 'vue-router';
const { send, service, state } = useDischargeRequestProcess();
onBeforeMount(() => {
  send('READY');
});
service.onTransition((transition) => {
  if (transition.value !== 'gotoReady' && transition.value !== 'start') {
    const loanApp = transition.context.loanApp;
    const key = transition.value as DischargeRequestProcessStepEnum;
    const name = DischargeRequestProcessSteps[key].route;
    let params: RouteParamsRaw | undefined;
    if (name === 'completed') {
      let finishType: string;
      if (loanApp.userType === 'Broker') {
        finishType = 'broker';
      } else if (loanApp.actionType === 'updateExisting') {
        if (state.value.context.from === 'crm') {
          finishType = 'income_expense';
        } else if (state.value.context.from === 'discharge') {
          finishType = 'discharge_request';
        } else {
          finishType = 'user_declaration';
        }
      } else {
        if (loanApp.loanType === LoanType.BRIDGING) {
          finishType = 'bridge_loan';
        } else {
          finishType = 'equity_release';
        }
      }
      params = { finishType };
    }
    router.push({ name, params });
  }
});
</script>

<template>
  <div></div>
</template>
